/*
 * WARNING: This file was automatically generated.
 * Changes must be made to the package.templateroot, or they will be lost!
 */
export enum ITitleOrDurationOrTypeOrWorkoutIdOrProgramIdOrListWorkoutIdOrCompletedMovementsOrStatsOrVideoIdOrTypeDetailOrSocialImageUrlOrWorkoutContextOr15MoreOrRedundant {
  Title = 'title',
  Duration = 'duration',
  Type = 'type',
  WorkoutId = 'workout_id',
  ProgramId = 'program_id',
  ListWorkoutId = 'list_workout_id',
  CompletedMovements = 'completed_movements',
  Stats = 'stats',
  VideoId = 'video_id',
  TypeDetail = 'type_detail',
  SocialImageUrl = 'social_image_url',
  WorkoutContext = 'workout_context',
  LiveWorkoutScheduleId = 'live_workout_schedule_id',
  MachineId = 'machine_id',
  SoftwareNumber = 'software_number',
  SleepScore = 'sleep_score',
  Summary = 'summary',
  WolfGeneratedId = 'wolf_generated_id',
  OriginId = 'origin_id',
  ReadinessScore = 'readiness_score',
  Id = 'id',
  UserId = 'user_id',
  Start = 'start',
  End = 'end',
  Origin = 'origin',
  Source = 'source',
  ClientTier = 'client_tier',
  Redundant = 'redundant',
}
